import { render, staticRenderFns } from "./CompanyListSideMenu.vue?vue&type=template&id=3f8b42d5"
import script from "./CompanyListSideMenu.vue?vue&type=script&lang=js"
export * from "./CompanyListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CompanyListSideMenu.vue?vue&type=style&index=0&id=3f8b42d5&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f8b42d5')) {
      api.createRecord('3f8b42d5', component.options)
    } else {
      api.reload('3f8b42d5', component.options)
    }
    module.hot.accept("./CompanyListSideMenu.vue?vue&type=template&id=3f8b42d5", function () {
      api.rerender('3f8b42d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/CompanyListSideMenu.vue"
export default component.exports